export default "__VITE_ASSET__CCwHBnbM__"